import { createPlayer, videoFeatures } from "@videojs/react";

export const player = createPlayer({ features: videoFeatures });
